import {
  AddInboundConsolidationInput,
  AddOutboundConsolidationInput,
} from '@returnmates/client-core/src/type/consolidation'
import inboundValidation from '@returnmates/client-core/src/utils/validation/createConsolidation'
import outboundValidation from '@returnmates/client-core/src/utils/validation/createOutboundConsolidation'
import Button from '@returnmates/ui-core/src/components/Button'
import ErrorBlock from '@returnmates/ui-core/src/components/ErrorBlock'
import Modal from '@returnmates/ui-core/src/components/Modal'
import clsx from 'clsx'
import { memo } from 'react'
import { Form } from 'react-final-form'

import useStyles from '../styles'
import ConsolidationModalDetails from './ConsolidationModalDetails'
import ContainerModalDetails from './ContainerModalDetails'

interface Props {
  onClose: () => void
  isOpen: boolean
  onCreate: (input: AddInboundConsolidationInput | AddOutboundConsolidationInput) => void
  isLoading: boolean
  isInboundModal?: boolean
}

function AddConsolidationModal({ isOpen, onClose, onCreate, isLoading, isInboundModal }: Props) {
  const classes = useStyles()

  return (
    <Modal isOpen={isOpen} onClose={onClose} width={448}>
      <div className={classes.modalWrapper}>
        <p className={classes.modalHeader}>Add {isInboundModal ? 'Consolidation' : 'Container'}</p>
        <Form
          onSubmit={onCreate}
          validate={isInboundModal ? inboundValidation : outboundValidation}
          render={({ handleSubmit, submitError }) => (
            <>
              <ErrorBlock message={submitError} />
              {isInboundModal ? <ConsolidationModalDetails /> : <ContainerModalDetails />}
              <div className={classes.modalButtons}>
                <Button
                  className={clsx(classes.button, classes.cancelButton, classes.modalCancelButton)}
                  onClick={onClose}
                  label="Cancel"
                  cancelButton
                />
                <Button
                  className={clsx(classes.button, classes.saveButton, classes.modalSaveButton)}
                  onClick={handleSubmit}
                  label="Add Consolidation"
                  isLoading={isLoading}
                />
              </div>
            </>
          )}
        />
      </div>
    </Modal>
  )
}

export default memo(AddConsolidationModal)
